// Note: Table name constants have been moved to src/utils/database/types.ts
// Import TABLE_NAMES from there instead of using these individual constants

export const DEFAULT_PASSWORD = '123456';

// file storage
export const FILE_DB_BUCKET_NAME = 'library';
export const ALL_GRADES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const ALL_CHAPTER = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const ZEPTO_MAIL_API_URL = 'api.zeptomail.ca/';

// Note: Cache table constants have also been moved to TABLE_NAMES
